import call from './call';
import messageShow from "./messageShow";
import {push} from "connected-react-router";
import {ADV_ORDERS_ROUTE} from "../components/Root/routes";
import {UPDATE_DATA} from "../types";

const getOrders= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            dispatch({type:UPDATE_DATA,payload:result[1]});
            dispatch(push(ADV_ORDERS_ROUTE));
        }
        else
            dispatch(messageShow({message: result[1].error, type: 'error'}));
    }
    dispatch(call("Service/getOrdersByID",formValues,onResult));
};
export default getOrders;